import { useEffect, useState } from "react";
import api from "../../../../../services/api.js";
import Modal from "react-modal";
import "../../style.css";

export default function CardMoeda({
    dados,
    actions
}) {

    const { DateTime } = require("luxon");

    const [showModalComparativo, setShowModalComparativo] = useState(false);
    const [loadingComparativo, setLoadingComparativo] = useState(false);
    const [tituloComparativo, setTituloComparativo] = useState("");
    const [dadosComparativo, setDadosComparativo] = useState([]);

    // =====================================================
    // MODAL FICHAS PAGAS
    // =====================================================
    const [showModalFichas, setShowModalFichas] = useState(false);
    const [loadingFichas, setLoadingFichas] = useState(false);
    const [dadosFichas, setDadosFichas] = useState([]);
    const [moedaSelecionada, setMoedaSelecionada] = useState(null);

    // =====================================================
    // MEMBROS DA EQUIPE PARA LANÇAMENTO DE VALES
    // =====================================================
    const [membrosEquipe, setMembrosEquipe] = useState([]);
    const [membroValeSelecionado, setMembroValeSelecionado] = useState("");
    const [loadingMembros, setLoadingMembros] = useState(false);

    const {
        dataInicial,
        dataFinal,
        comparativo,
        moeda,
        despesas,
        depositos,
        vales,
        bancos,
        categorias,
        categoriaDespesa,
        descricaoDespesa,
        valorDespesa,
        bancoDeposito,
        valorDeposito,
        valorVale,
        totalRecebido,
        totalDespesas,
        totalDepositos,
        totalVales,
        totalLiquido
    } = dados;

    const {
        setDataInicial,
        setDataFinal,
        setCategoriaDespesa,
        setDescricaoDespesa,
        setValorDespesa,
        setBancoDeposito,
        setValorDeposito,
        setValorVale,
        adicionarDespesa,
        removerDespesa,
        adicionarDeposito,
        removerDeposito,
        adicionarVale,
        removerVale,
        formatarMoeda
    } = actions;

    useEffect(() => {
        async function carregarMembrosEquipe() {
            try {
                setLoadingMembros(true);

                const response = await api.get("v1/vales/membros", {
                    params: {
                        codequipe: localStorage.getItem("tempCodEquipe"),
                        dt1: dataInicial,
                        dt2: dataFinal
                    },
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("tempToken")}`
                    }
                });

                // A consulta retorna CodFuncionario, Nome, Telefone, WhatsApp e QtdeVenda.
                const resultado = response.data;
                const lista = Array.isArray(resultado)
                    ? resultado
                    : resultado?.dados || resultado?.membros || resultado?.data || [];

                // Guarda sempre um array, independentemente do formato do retorno da API.
                setMembrosEquipe(Array.isArray(lista) ? lista : []);
            } catch (erro) {
                console.error("Erro ao carregar membros da equipe:", erro);
                alert(
                    erro?.response?.data?.erro ||
                    "Não foi possível carregar os membros da equipe."
                );
            } finally {
                setLoadingMembros(false);
            }
        }

        carregarMembrosEquipe();
    }, [dataInicial, dataFinal]);

    // A API pode retornar os nomes das propriedades em minúsculas ou maiúsculas.
    function obterCodigoMembro(membro) {
        return membro?.codfuncionario ?? membro?.CodFuncionario;
    }

    function obterNomeMembro(membro) {
        return membro?.nome ?? membro?.Nome ?? "Funcionário não identificado";
    }

    function obterNomeFuncionarioVale(vale) {
        const nomeDireto = vale?.nome ?? vale?.Nome;
        if (nomeDireto) return nomeDireto;

        const codigoVale = vale?.codfuncionario ?? vale?.CodFuncionario;
        const membro = membrosEquipe.find(
            (item) => String(obterCodigoMembro(item)) === String(codigoVale)
        );

        return membro ? obterNomeMembro(membro) : "Funcionário não identificado";
    }

    function handleAdicionarVale() {
        if (!membroValeSelecionado) {
            alert("Selecione um membro da equipe para adicionar o vale.");
            return;
        }

        const valor = Number(String(valorVale).replace(",", "."));
        if (!Number.isFinite(valor) || valor <= 0) {
            alert("Informe um valor de vale maior que zero.");
            return;
        }

        // Passa o código do funcionário selecionado para a ação responsável pelo lançamento.
        adicionarVale(membroValeSelecionado);
    }

    async function abrirComparativo(tipo, titulo) {
        if (
            (tipo === "COBRADAS" && comparativo.cobradas === 0) ||
            (tipo === "RENOVADAS" && comparativo.renovadas === 0) ||
            (tipo === "CAIDAS" && comparativo.caidas === 0) ||
            (tipo === "VENDIDAS" && comparativo.vendidas === 0)
        ) {
            return;
        }

        try {
            setLoadingComparativo(true);

            const response = await api.get(
                "v1/comparativo",
                {
                    params: {
                        tipo,
                        datainicial: dataInicial,
                        datafinal: dataFinal,
                        codequipe: localStorage.getItem("tempCodEquipe"),
                    },
                    headers: {
                        Authorization:
                            `Bearer ${localStorage.getItem("tempToken")}`
                    }
                }
            );
            setTituloComparativo(titulo);
            setDadosComparativo(response.data || []);
            setShowModalComparativo(true);
        }
        catch (erro) {
            alert(
                erro?.response?.data?.erro ||
                "Erro ao consultar o comparativo."
            );
        }
        finally {
            setLoadingComparativo(false);
        }
    }

    // =====================================================
    // ABRIR FICHAS PAGAS
    // =====================================================
    async function abrirFichasPagas(item) {
        try {
            setLoadingFichas(true);
            // Guarda a moeda selecionada para mostrar no título
            setMoedaSelecionada(item);

            const response = await api.get(
                "v1/pagamentos/fichaspagas",
                {
                    params: {
                        codmoeda: item.codmoeda,
                        datainicial: dataInicial,
                        datafinal: dataFinal,
                        codequipe: localStorage.getItem("tempCodEquipe")
                    },
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("tempToken")}`
                    }
                }
            );

            setDadosFichas(response.data);
            setShowModalFichas(true);
        } catch (erro) {
            console.error("Erro ao buscar fichas pagas:", erro);
            alert(erro?.response?.data?.erro || "Erro ao consultar as fichas pagas.");
        } finally {
            setLoadingFichas(false);
        }
    }

    function formatDate(dateStr) {

        return dateStr
            ? DateTime
                .fromISO(dateStr)
                .plus({ hours: 3 })
                .toFormat("dd/MM/yyyy")
            : "";

    }

    return (
        <>
            <div className="card shadow-sm p-4 mb-4">
                {/* =====================================================
                    CABEÇALHO
                ====================================================== */}
                <div className="header-fechamento">
                    <h4 className="mb-0">
                        <i className="fa fa-money-bill-wave me-2 text-success"></i>
                        Fechamento da Viagem
                    </h4>

                    <div className="datas-grid">
                        <div className="campo-data">
                            <label>
                                Data Inicial
                            </label>
                            <input
                                type="date"
                                className="form-control"
                                value={dataInicial}
                                onChange={(e) =>
                                    setDataInicial(e.target.value)
                                }
                            />
                        </div>

                        <div className="campo-data">
                            <label>
                                Data Final
                            </label>

                            <input
                                type="date"
                                className="form-control"
                                value={dataFinal}
                                onChange={(e) =>
                                    setDataFinal(e.target.value)
                                }
                            />
                        </div>
                    </div>
                </div>

                {/* =====================================================
                    COMPARATIVOS
                ====================================================== */}
                <div className="row g-3 mb-4 mt-1">
                    {/* COBRADAS */}
                    <div className="col-6 col-lg-3">
                        <div
                            className={`card border-0 bg-primary text-white text-center p-4 comparativo-card ${comparativo.cobradas > 0
                                ? "comparativo-click"
                                : ""
                                }`}
                            style={{
                                cursor:
                                    comparativo.cobradas > 0
                                        ? "pointer"
                                        : "default"
                            }}
                            onClick={() =>
                                comparativo.cobradas > 0 &&
                                abrirComparativo(
                                    "COBRADAS",
                                    "Cobradas"
                                )
                            }
                        >
                            <small>
                                {comparativo.cobradas > 0 && (
                                    <i className="fa fa-search me-2"></i>
                                )}
                                Cobradas
                            </small>

                            <h2>
                                {comparativo.cobradas}
                            </h2>
                        </div>
                    </div>

                    {/* RENOVADAS */}
                    <div className="col-6 col-lg-3">
                        <div
                            className={`card border-0 bg-primary text-white text-center p-4 comparativo-card ${comparativo.renovadas > 0
                                ? "comparativo-click"
                                : ""
                                }`}
                            style={{
                                cursor:
                                    comparativo.renovadas > 0
                                        ? "pointer"
                                        : "default"
                            }}
                            onClick={() =>
                                comparativo.renovadas > 0 &&
                                abrirComparativo(
                                    "RENOVADOS",
                                    "Renovados"
                                )
                            }
                        >
                            <small>
                                {comparativo.renovadas > 0 && (
                                    <i className="fa fa-search me-2"></i>
                                )}
                                Renovadas
                            </small>

                            <h2>
                                {comparativo.renovadas}
                            </h2>
                        </div>
                    </div>

                    {/* CAÍDAS */}
                    <div className="col-6 col-lg-3">
                        <div
                            className={`card border-0 bg-primary text-white text-center p-4 comparativo-card ${comparativo.caidas > 0
                                ? "comparativo-click"
                                : ""
                                }`}
                            style={{
                                cursor:
                                    comparativo.caidas > 0
                                        ? "pointer"
                                        : "default"
                            }}
                            onClick={() =>
                                comparativo.caidas > 0 &&
                                abrirComparativo(
                                    "CAIDAS",
                                    "Caidas"
                                )
                            }
                        >
                            <small>
                                {comparativo.caidas > 0 && (
                                    <i className="fa fa-search me-2"></i>
                                )}
                                Caídas
                            </small>

                            <h2>
                                {comparativo.caidas}
                            </h2>
                        </div>
                    </div>

                    {/* VENDIDAS */}
                    <div className="col-6 col-lg-3">
                        <div
                            className={`card border-0 bg-primary text-white text-center p-4 comparativo-card ${comparativo.vendidas > 0
                                ? "comparativo-click"
                                : ""
                                }`}
                            style={{
                                cursor:
                                    comparativo.vendidas > 0
                                        ? "pointer"
                                        : "default"
                            }}
                            onClick={() =>
                                comparativo.vendidas > 0 &&
                                abrirComparativo(
                                    "VENDIDAS",
                                    "Vendidas"
                                )
                            }
                        >
                            <small>
                                {comparativo.vendidas > 0 && (
                                    <i className="fa fa-search me-2"></i>
                                )}
                                Vendidas
                            </small>

                            <h2>
                                {comparativo.vendidas}
                            </h2>
                        </div>
                    </div>
                </div>

                {/* =====================================================
                    PAGAMENTOS
                ====================================================== */}
                <div className="card border-0 bg-light p-3 mb-4">
                    <h5 className="mb-3">
                        Pagamentos
                    </h5>

                    <table className="table table-striped align-middle">
                        <thead>
                            <tr>
                                <th>
                                    Forma
                                </th>

                                <th className="text-end">
                                    Valor
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            {moeda.map((item, index) => (
                                <tr
                                    key={item.codmoeda}
                                    className="linha-pagamento"
                                    onClick={() => abrirFichasPagas(item)}
                                    style={{ cursor: "pointer" }}
                                    title="Clique para visualizar as fichas pagas"
                                >
                                    <td>
                                        <i className="fa fa-search me-2 text-primary"></i>
                                        {item.moeda}
                                    </td>
                                    <td className="text-end">
                                        {formatarMoeda(item.valor)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>

                        <tfoot>
                            <tr>
                                <th>
                                    Total Recebido
                                </th>

                                <th className="text-end text-success">
                                    {formatarMoeda(totalRecebido)}
                                </th>
                            </tr>
                        </tfoot>
                    </table>
                </div>

                {/* =====================================================
                    DESPESAS
                ====================================================== */}
                <div className="card border-0 bg-light p-3 mb-4">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="mb-0">
                            <i className="fa fa-wallet me-2"></i>
                            Despesas da Viagem
                        </h5>

                        <span className="badge bg-danger">
                            {formatarMoeda(totalDespesas)}
                        </span>
                    </div>

                    <div className="categoria-grid">
                        {categorias.map((categoria) => (
                            <button
                                key={categoria}
                                type="button"
                                className={`btn btn-categoria ${categoriaDespesa === categoria
                                    ? "ativo"
                                    : ""
                                    }`}
                                onClick={() =>
                                    setCategoriaDespesa(categoria)
                                }
                            >
                                {categoriaDespesa === categoria && (
                                    <i className="fa fa-check-circle me-2"></i>
                                )}
                                {categoria}
                            </button>
                        ))}
                    </div>

                    {categoriaDespesa === "Outro" && (
                        <div className="mt-3">
                            <input
                                className="form-control"
                                placeholder="Descrição da despesa"
                                value={descricaoDespesa}
                                onChange={(e) =>
                                    setDescricaoDespesa(e.target.value)
                                }
                            />
                        </div>
                    )}

                    <div className="row g-2 mt-4 align-items-stretch">
                        <div className="col-lg-8 col-7">
                            <input
                                type="number"
                                step="0.01"
                                className="form-control"
                                placeholder="Valor da despesa"
                                value={valorDespesa}
                                onChange={(e) =>
                                    setValorDespesa(e.target.value)
                                }
                            />
                        </div>

                        <div className="col-lg-4 col-5">
                            <button
                                type="button"
                                className="btn btn-primary btn-adicionar w-100"
                                onClick={adicionarDespesa}
                            >
                                <i className="fa fa-plus me-2"></i>
                                Adicionar
                            </button>
                        </div>
                    </div>

                    <hr />

                    <div className="lista-despesas">
                        {despesas.length === 0 && (
                            <div className="text-center text-muted py-3">
                                Nenhuma despesa informada.
                            </div>
                        )}

                        {despesas.map((d, index) => (
                            <div
                                key={d.coddespesa ?? index}
                                className="despesa-item"
                            >
                                <div className="despesa-info">
                                    <strong>
                                        {d.categoria}
                                    </strong>

                                    {d.categoria === "Outro" && (
                                        <div className="text-muted small">
                                            {d.descricao}
                                        </div>
                                    )}

                                    {d.dtlancamento && (
                                        <div className="data-lancamento">
                                            <i className="fa fa-calendar-alt me-1"></i>
                                            {formatDate(d.dtlancamento)}
                                        </div>
                                    )}
                                </div>

                                <div className="d-flex align-items-center">
                                    <span className="me-3 fw-bold">
                                        {formatarMoeda(d.valor)}
                                    </span>

                                    <button
                                        type="button"
                                        className="btn btn-outline-danger btn-sm"
                                        onClick={() =>
                                            removerDespesa(d.coddespesa)
                                        }
                                    >
                                        <i className="fa fa-trash" />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* =====================================================
                    DEPÓSITOS
                ====================================================== */}
                <div className="card border-0 bg-light p-3 mb-4">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="mb-0">
                            <i className="fa fa-university me-2"></i>
                            Depósitos
                        </h5>

                        <span className="badge bg-success">
                            {formatarMoeda(totalDepositos)}
                        </span>
                    </div>

                    {/* BANCO */}
                    <div className="mb-3">
                        <label className="form-label">
                            Banco
                        </label>

                        <select
                            className="form-select"
                            value={bancoDeposito}
                            onChange={(e) =>
                                setBancoDeposito(e.target.value)
                            }
                        >
                            <option value="">
                                Selecione o banco
                            </option>

                            {bancos.map((banco) => (
                                <option
                                    key={
                                        banco.codigo ||
                                        banco.codbanco
                                    }
                                    value={
                                        banco.codigo ||
                                        banco.codbanco
                                    }
                                >
                                    {banco.nome ||
                                        banco.banco}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* VALOR + BOTÃO */}
                    <div className="row g-2 align-items-stretch">
                        <div className="col-lg-8 col-7">
                            <input
                                type="number"
                                step="0.01"
                                className="form-control"
                                placeholder="Valor do depósito"
                                value={valorDeposito}
                                onChange={(e) =>
                                    setValorDeposito(e.target.value)
                                }
                            />
                        </div>

                        <div className="col-lg-4 col-5">
                            <button
                                type="button"
                                className="btn btn-primary btn-adicionar w-100"
                                onClick={adicionarDeposito}
                            >
                                <i className="fa fa-plus me-2"></i>
                                Adicionar
                            </button>
                        </div>
                    </div>

                    <hr />

                    {/* LISTA */}
                    <div className="lista-depositos">
                        {depositos.length === 0 && (
                            <div className="text-center text-muted py-3">
                                Nenhum depósito informado.
                            </div>
                        )}

                        {depositos.map((deposito, index) => (
                            <div
                                key={
                                    deposito.coddeposito ??
                                    index
                                }
                                className="deposito-item"
                            >
                                <div className="deposito-info">
                                    <strong>
                                        {deposito.banco}
                                    </strong>

                                    {deposito.dtlancamento && (
                                        <div className="data-lancamento">
                                            <i className="fa fa-calendar-alt me-1"></i>
                                            {formatDate(
                                                deposito.dtlancamento
                                            )}
                                        </div>
                                    )}
                                </div>

                                <div className="d-flex align-items-center">
                                    <span className="me-3 fw-bold">
                                        {formatarMoeda(
                                            deposito.valor
                                        )}
                                    </span>

                                    <button
                                        type="button"
                                        className="btn btn-outline-danger btn-sm"
                                        onClick={() =>
                                            removerDeposito(
                                                deposito.coddeposito
                                            )
                                        }
                                    >
                                        <i className="fa fa-trash"></i>
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* =====================================================
                    VALES
                ====================================================== */}
                <div className="card border-0 bg-light p-3 mb-4">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="mb-0">
                            <i className="fa fa-hand-holding-usd me-2"></i>
                            Vales
                        </h5>

                        <span className="badge bg-warning text-dark">
                            {formatarMoeda(totalVales)}
                        </span>
                    </div>

                    {/* MEMBRO DA EQUIPE */}
                    <div className="mb-3">
                        <label className="form-label" htmlFor="membroVale">
                            Membro da equipe
                        </label>

                        <select
                            id="membroVale"
                            className="form-select"
                            value={membroValeSelecionado}
                            onChange={(e) => setMembroValeSelecionado(e.target.value)}
                            disabled={loadingMembros || membrosEquipe.length === 0}
                        >
                            <option value="">
                                {loadingMembros
                                    ? "Carregando membros..."
                                    : membrosEquipe.length === 0
                                        ? "Nenhum membro encontrado"
                                        : "Selecione o membro da equipe"}
                            </option>

                            {membrosEquipe.map((membro, index) => {
                                const codigo = obterCodigoMembro(membro);
                                if (codigo === undefined || codigo === null) return null;

                                return (
                                    <option
                                        key={`${codigo}-${index}`}
                                        value={String(codigo)}
                                    >
                                        {obterNomeMembro(membro)}
                                        {(membro.qtdevenda ?? membro.QtdeVenda) !== undefined
                                            ? ` — ${membro.qtdevenda ?? membro.QtdeVenda} vendas`
                                            : ""}
                                    </option>
                                );
                            })}
                        </select>
                    </div>

                    {/* VALOR + BOTÃO */}
                    <div className="row g-2 align-items-stretch">
                        <div className="col-lg-8 col-7">
                            <input
                                type="number"
                                step="0.01"
                                min="0.01"
                                className="form-control"
                                placeholder="Valor do vale"
                                value={valorVale}
                                onChange={(e) => setValorVale(e.target.value)}
                            />
                        </div>

                        <div className="col-lg-4 col-5">
                            <button
                                type="button"
                                className="btn btn-primary btn-adicionar w-100"
                                onClick={handleAdicionarVale}
                                disabled={loadingMembros || membrosEquipe.length === 0}
                            >
                                <i className="fa fa-plus me-2"></i>
                                Adicionar
                            </button>
                        </div>
                    </div>

                    <hr />

                    {/* LISTA DOS VALES */}
                    <div className="lista-vales">
                        {vales.length === 0 && (
                            <div className="text-center text-muted py-3">
                                Nenhum vale informado.
                            </div>
                        )}

                        {vales.map((vale, index) => (
                            <div
                                key={
                                    vale.codvale ??
                                    index
                                }
                                className="deposito-item"
                            >
                                <div className="deposito-info">
                                    <strong>
                                        {obterNomeFuncionarioVale(vale)}
                                    </strong>

                                    {vale.dtlancamento && (
                                        <div className="data-lancamento">
                                            <i className="fa fa-calendar-alt me-1"></i>
                                            {formatDate(
                                                vale.dtlancamento
                                            )}
                                        </div>
                                    )}
                                </div>

                                <div className="d-flex align-items-center">
                                    <span className="me-3 fw-bold">
                                        {formatarMoeda(
                                            vale.valor
                                        )}
                                    </span>

                                    <button
                                        type="button"
                                        className="btn btn-outline-danger btn-sm"
                                        onClick={() =>
                                            removerVale(
                                                vale.codvales
                                            )
                                        }
                                    >
                                        <i className="fa fa-trash"></i>
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* =====================================================
                    RESUMO
                ====================================================== */}

                <div className="row g-3">
                    <div className="col-4">
                        <div className="resumo-card recebido">
                            <h6>
                                Recebido
                            </h6>

                            <h4 className="text-success">
                                {formatarMoeda(
                                    totalRecebido
                                )}
                            </h4>
                        </div>
                    </div>

                    <div className="col-4">
                        <div className="resumo-card despesa">
                            <h6>
                                Despesas
                            </h6>

                            <h4 className="text-danger">
                                {formatarMoeda(
                                    totalDespesas
                                )}
                            </h4>
                        </div>
                    </div>

                    <div className="col-4">
                        <div className="resumo-card liquido">
                            <h6>
                                Líquido
                            </h6>

                            <h3 className="text-primary">
                                {formatarMoeda(
                                    totalLiquido
                                )}
                            </h3>
                        </div>
                    </div>
                </div>
            </div>

            {/* =====================================================
                MODAL COMPARATIVO
            ====================================================== */}
            <Modal
                isOpen={showModalComparativo}
                onRequestClose={() =>
                    setShowModalComparativo(false)
                }
                shouldCloseOnOverlayClick={true}
                className="modal-comparativo"
                overlayClassName="overlay-comparativo"
            >
                <div className="modal-header">
                    <h4 className="mb-0">
                        <i className="fa fa-search me-2"></i>
                        {tituloComparativo}
                    </h4>

                    <button
                        type="button"
                        className="btn btn-danger"

                        onClick={() =>
                            setShowModalComparativo(false)
                        }
                    >
                        <i className="fa fa-times"></i>
                    </button>
                </div>

                <div className="modal-body">
                    {loadingComparativo ? (
                        <div className="text-center p-5">
                            <div
                                className="spinner-border text-primary"
                                role="status"
                            />

                            <div className="mt-3">
                                Carregando...
                            </div>
                        </div>
                    ) : (
                        <>
                            {/* DESKTOP */}
                            <div className="d-none d-lg-block">
                                <table className="table table-striped table-hover">
                                    <thead>
                                        <tr>
                                            <th>
                                                Venda
                                            </th>

                                            <th>
                                                Data
                                            </th>

                                            <th>
                                                Cliente
                                            </th>

                                            <th>
                                                CPF
                                            </th>

                                            <th>
                                                Cidade
                                            </th>

                                            <th>
                                                Telefone
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {dadosComparativo.length === 0 && (
                                            <tr>
                                                <td
                                                    colSpan={6}
                                                    className="text-center text-muted"
                                                >
                                                    Nenhum registro encontrado.
                                                </td>
                                            </tr>
                                        )}

                                        {dadosComparativo.map((item) => (
                                            <tr
                                                key={item.codvenda}
                                            >
                                                <td>
                                                    {item.codvenda}
                                                </td>

                                                <td>
                                                    {formatDate(
                                                        item.dtvenda
                                                    )}
                                                </td>

                                                <td>
                                                    {item.nome}
                                                </td>

                                                <td>
                                                    {item.cpf}
                                                </td>

                                                <td>
                                                    {item.cidade}
                                                </td>

                                                <td>
                                                    {item.telefone}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            {/* MOBILE */}
                            <div className="d-block d-lg-none">
                                {dadosComparativo.length === 0 && (
                                    <div className="text-center text-muted">
                                        Nenhum registro encontrado.
                                    </div>
                                )}

                                {dadosComparativo.map((item) => (
                                    <div
                                        key={item.codvenda}
                                        className="card shadow-sm mb-3"
                                    >
                                        <div className="card-body">
                                            <h5>
                                                Venda #{item.codvenda}
                                            </h5>

                                            <hr />

                                            <div>
                                                <strong>
                                                    Data
                                                </strong>

                                                <div>
                                                    {formatDate(
                                                        item.dtvenda
                                                    )}
                                                </div>
                                            </div>

                                            <div className="mt-2">
                                                <strong>
                                                    Cliente
                                                </strong>

                                                <div>
                                                    {item.nome}
                                                </div>
                                            </div>

                                            <div className="mt-2">
                                                <strong>
                                                    CPF
                                                </strong>

                                                <div>
                                                    {item.cpf}
                                                </div>
                                            </div>

                                            <div className="mt-2">
                                                <strong>
                                                    Telefone
                                                </strong>

                                                <div>
                                                    {item.telefone}
                                                </div>
                                            </div>

                                            <div className="mt-2">
                                                <strong>
                                                    Endereço
                                                </strong>

                                                <div>
                                                    {item.endereco},{" "}
                                                    {item.numero}
                                                </div>
                                            </div>

                                            <div className="mt-2">
                                                <strong>
                                                    Bairro
                                                </strong>

                                                <div>
                                                    {item.bairro}
                                                </div>
                                            </div>

                                            <div className="mt-2">
                                                <strong>
                                                    Cidade
                                                </strong>

                                                <div>
                                                    {item.cidade}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>
                    )}
                </div>
            </Modal>

            {/* =====================================================
            MODAL FICHAS PAGAS
            ===================================================== */}
            <Modal
                isOpen={showModalFichas}
                onRequestClose={() => setShowModalFichas(false)}
                shouldCloseOnOverlayClick={true}
                className="modal-fichas"
                overlayClassName="overlay-fichas"
            >
            {/* =====================================================
            CABEÇALHO
            ====================================================== */}
                <div className="modal-header">
                    <div>
                        <h4 className="mb-1">
                            <i className="fa fa-file-invoice-dollar me-2"></i>
                            Fichas Pagas
                        </h4>

                        {moedaSelecionada && (
                            <small className="text-muted">
                                {moedaSelecionada.moeda}
                                {" - "}
                                {formatarMoeda(moedaSelecionada.valor)}
                            </small>
                        )}
                    </div>

                    <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() => setShowModalFichas(false)}
                    >
                        <i className="fa fa-times"></i>
                    </button>
                </div>

            {/* =====================================================
            CORPO
            ====================================================== */}
                <div className="modal-body">
                    {loadingFichas ? (
                        <div className="text-center p-5">
                            <div
                                className="spinner-border text-primary"
                                role="status"
                            />

                            <div className="mt-3">
                                Carregando fichas...
                            </div>
                        </div>
                    ) : dadosFichas.length === 0 ? (
                        <div className="text-center text-muted p-5">
                            <i
                                className="fa fa-folder-open fa-3x mb-3"
                            ></i>

                            <div>
                                Nenhuma ficha encontrada.
                            </div>
                        </div>
                    ) : (
                        <>
                        {/* =================================================
                        DESKTOP
                        ================================================== */}
                            <div className="d-none d-md-block">
                                <div className="table-responsive">
                                    <table className="table table-striped table-hover align-middle">
                                        <thead>
                                            <tr>
                                                <th>
                                                    Venda
                                                </th>

                                                <th>
                                                    Data Pagamento
                                                </th>

                                                <th>
                                                    Cliente
                                                </th>

                                                <th>
                                                    Endereço
                                                </th>

                                                <th>
                                                    Telefone
                                                </th>

                                                <th className="text-end">
                                                    Venda
                                                </th>

                                                <th className="text-end">
                                                    Empresa
                                                </th>

                                                <th className="text-end">
                                                    Pago
                                                </th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {dadosFichas.map(
                                                (item, index) => (
                                                    <tr
                                                        key={item.codvenda}
                                                    >
                                                        <td>
                                                            <strong>
                                                                # {item.codvenda}
                                                            </strong>
                                                        </td>

                                                        <td>
                                                            {formatDate(item.dtpagamento)}
                                                        </td>

                                                        <td>
                                                            {item.nome}
                                                        </td>

                                                        <td>
                                                            {item.endereco}
                                                        </td>

                                                        <td>
                                                            {item.telefone}
                                                        </td>

                                                        <td className="text-end">
                                                            {formatarMoeda(item.valorvenda)}
                                                        </td>

                                                        <td className="text-end">
                                                            {formatarMoeda(item.valorempresa)}
                                                        </td>

                                                        <td className="text-end fw-bold text-success">
                                                            {formatarMoeda(item.valorpago)}
                                                        </td>
                                                    </tr>
                                                )
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                        {/* =================================================
                        MOBILE
                        ================================================== */}
                            <div className="d-md-none">
                                {dadosFichas.map(
                                    (item, index) => (
                                        <div
                                            key={item.codvenda}
                                            className="card shadow-sm"
                                        >
                                            <div className="card-body">
                                                {/* CABEÇALHO DO CARD */}
                                                <div className="d-flex justify-content-between align-items-start">
                                                    <div>
                                                        <small className="text-muted">
                                                            Venda
                                                        </small>

                                                        <h5 className="mb-0">
                                                            # {item.codvenda}
                                                        </h5>
                                                    </div>

                                                    <div className="text-end">
                                                        <small className="text-muted">
                                                            Pago
                                                        </small>

                                                        <div className="fw-bold text-success">
                                                            {formatarMoeda(item.valorpago)}
                                                        </div>
                                                    </div>
                                                </div>

                                                <hr />

                                                {/* CLIENTE */}
                                                <div className="mb-3">
                                                    <small className="text-muted">
                                                        Cliente
                                                    </small>

                                                    <div className="fw-semibold">
                                                        {item.nome}
                                                    </div>
                                                </div>

                                                {/* DATA */}
                                                <div className="mb-3">
                                                    <small className="text-muted">
                                                        Data do pagamento
                                                    </small>

                                                    <div>
                                                        {formatDate(item.dtpagamento)}
                                                    </div>
                                                </div>

                                                {/* ENDEREÇO */}
                                                <div className="mb-3">
                                                    <small className="text-muted">
                                                        Endereço
                                                    </small>

                                                    <div>
                                                        {item.endereco}
                                                    </div>
                                                </div>

                                                {/* TELEFONE */}
                                                <div className="mb-3">
                                                    <small className="text-muted">
                                                        Telefone
                                                    </small>

                                                    <div>
                                                        {item.telefone}
                                                    </div>
                                                </div>

                                                {/* VALORES */}
                                                <div className="row g-2">
                                                    <div className="col-6">
                                                        <div className="border rounded p-2">
                                                            <small className="text-muted">
                                                                Valor da Venda
                                                            </small>

                                                            <div className="fw-semibold">
                                                                {formatarMoeda(item.valorvenda)}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-6">
                                                        <div className="border rounded p-2">
                                                            <small className="text-muted">
                                                                Valor Empresa
                                                            </small>

                                                            <div className="fw-semibold">
                                                                {formatarMoeda(item.valorempresa)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                )}
                            </div>
                        </>
                    )}
                </div>

                {/* =====================================================
        RODAPÉ
    ====================================================== */}
                <div className="modal-footer">
                    <span className="text-muted me-auto">
                        {dadosFichas.length}
                        {" "}
                        {dadosFichas.length === 1 ? "ficha" : "fichas"}
                    </span>

                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setShowModalFichas(false)}
                    >
                        Fechar
                    </button>
                </div>
            </Modal>
        </>
    );
}